import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import { Study } from 'src/app/models/study';
import * as researcherStudyActions from './um-study.actions';

export interface ResearcherStudyState extends EntityState<Study> {
  loadingResearcherStudies: boolean;
  researcherStudiesLoaded: boolean;
  selectedResearcherStudy: Study;
}

export const researcherStudyAdapter: EntityAdapter<Study> = createEntityAdapter<Study>({});

export const initialResearchStudyState: ResearcherStudyState = researcherStudyAdapter.getInitialState({
  loadingResearcherStudies: false,
  researcherStudiesLoaded: false,
  selectedResearcherStudy: null,
});

export const reducer = createReducer(
  initialResearchStudyState,
  on(researcherStudyActions.getResearcherStudies, (state) => {
    return {
      ...state,
      loadingResearcherStudies: true,
      researcherStudiesLoaded: false,
      isSideNavOpen: false,
    };
  }),
  on(researcherStudyActions.getResearcherStudiesSuccess, (state, { studies }) => {
    return researcherStudyAdapter.setAll(studies, {
      ...state,
      loadingResearcherStudies: false,
      researcherStudiesLoaded: true,
    });
  }),
  on(researcherStudyActions.getResearcherStudiesError, (state) => {
    return {
      ...state,
      loadingResearcherStudies: false,
      researcherStudiesLoaded: false,
    };
  }),
  on(researcherStudyActions.changeUmResearcherStudyAccessSuccess, (state, { changedStudy }) => {
    return researcherStudyAdapter.updateOne(
      { changes: changedStudy, id: changedStudy.id },
      {
        ...state,
      }
    );
  }),
  on(researcherStudyActions.deleteStudySuccess, (state, { deletedStudy }) => {
    return researcherStudyAdapter.removeOne(deletedStudy.id, {
      ...state,
    });
  })
);

export function researcherStudyReducer(state: ResearcherStudyState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = researcherStudyAdapter.getSelectors();
